module.exports = {
  costOfSchoolComponentEvents: {
    CostOfSchoolFromHomepage: {
      code: 'Homepage',
      events: {
        CosHomepageStartUniqueClick: {
          description:
            'Triggers when a unique user clicks a Cost of School entry point from the SS homepage to start the feature.',
          eventHub: {
            code: 'StartUniqueClick',
            action: 'Homepage_Start_Unique_Click'
          },
          ga: {
            action: 'COS — Homepage_Start_Unique_Click'
          }
        },
        CosHomepageStartLinkClick: {
          description:
            'Triggers when a user clicks a Cost of School entry point from the SS homepage to start the feature.',
          eventHub: {
            code: 'StartLinkClick',
            action: 'Homepage_Start_Link_Click'
          },
          ga: {
            action: 'COS — Homepage_Start_Link_Click'
          }
        }
      }
    },
    CostOfSchoolEntry: {
      code: 'CostOfSchoolEntry',
      events: {
        CosStartScreenExit: {
          description: 'Triggered when user exits or navigates away from the Start screen without progressing.',
          eventHub: {
            code: 'ScreenExit',
            action: 'Start_Screen_Exit'
          },
          ga: {
            action: 'COS — Start_Screen_Exit'
          }
        }
      }
    },
    CostOfSchoolFromDigitalDashboard: {
      code: 'Dashboard',
      events: {
        CosDashboardStartUniqueClick: {
          description: 'Triggers when a unique user clicks a Cost of School entry point from Digital dashboard.',
          eventHub: {
            code: 'StartUniqueClick',
            action: 'Dashboard_Start_Unique_Click'
          },
          ga: {
            action: 'COS — Dashboard_Start_Unique_Click'
          }
        },
        CosDashboardStartLinkClick: {
          description: 'Triggers when a unique user clicks a Cost of School entry point from Digital dashboard.',
          eventHub: {
            code: 'StartLinkClick',
            action: 'Dashboard_Start_Link_Click'
          },
          ga: {
            action: 'COS — Dashboard_Start_Link_Click'
          }
        }
      }
    },
    CostOfSchoolBeneficiaryProfile: {
      code: 'BeneficiaryProfile',
      events: {
        CosSessionStart: {
          description: 'Triggered when the user enters the Cost of School tool on the beneficiary profile page.',
          eventHub: {
            code: 'SessionStart',
            action: 'Session_Start'
          },
          ga: {
            action: 'COS — Session_Start'
          }
        },
        CosSessionEnd: {
          description:
            'Triggered when the user navigates out of the Cost of School tool on the beneficiary profile page.',
          eventHub: {
            code: 'SessionEnd',
            action: 'Session_End',
            dataKeys: ['duration']
          },
          ga: {
            action: 'COS — Session_End'
          }
        }
      }
    },
    CostOfSchoolMyFutureScholar: {
      code: 'MyFutureScholar',
      events: {
        CosMyFutureScholarCtaClick: {
          description:
            'Triggered whenever a CTA (Customize, Save, or Cancel) is clicked on the My Future Scholar screen (once per session).',
          eventHub: {
            code: 'CtaClick',
            action: 'My_Future_Scholar_Cta_Click',
            dataKeys: ['screenName', 'ctaType']
          },
          ga: {
            action: 'COS — My_Future_Scholar_Cta_Click_[$.ctaType]'
          }
        },
        CosMyFutureScholarScreenTime: {
          description: 'Tracks the duration spent on the My Future Scholar screen before any CTA is clicked.',
          eventHub: {
            code: 'ScreenTime',
            action: 'My_Future_Scholar_Screen_Time',
            dataKeys: ['screenName', 'startTime', 'endTime', 'duration']
          }
        },
        CosMyFutureScholarScreenExit: {
          description:
            'Triggered when user exits or navigates away from the My Future Scholar screen without completing education goal.',
          eventHub: {
            code: 'ScreenExit',
            action: 'My_Future_Scholar_Screen_Exit',
            dataKeys: ['screenName']
          }
        },
        ga: {
          action: 'COS — My_Future_Scholar_Screen_Exit'
        }
      }
    },
    CostOfSchoolCustomize: {
      code: 'Customize',
      events: {
        CosCustomizeCtaClick: {
          description: "Triggered whenever a CTA (Apply or Reset) is clicked on the Customize What's Included screen.",
          eventHub: {
            code: 'CtaClick',
            action: 'Customize_Cta_Click',
            dataKeys: ['screenName', 'ctaType']
          },
          ga: {
            action: 'COS — Customize_Cta_Click_[$.ctaType]'
          }
        },
        CosCustomizeScreenTime: {
          description: "Tracks the duration spent on the Customize What's Included screen before any CTA is clicked.",
          eventHub: {
            code: 'ScreenTime',
            action: 'Customize_Screen_Time',
            dataKeys: ['screenName', 'startTime', 'endTime', 'duration']
          }
        },
        CosCustomizeScreenExit: {
          description:
            'Triggered when user exits or navigates away from Customize screen without completing education goal.',
          eventHub: {
            code: 'ScreenExit',
            action: 'Customize_Screen_Exit',
            dataKeys: ['screenName']
          }
        },
        ga: {
          action: 'COS — Customize_Screen_Exit'
        }
      }
    },
    CostOfSchoolEducationGoal: {
      code: 'EducationGoal',
      events: {
        CosFieldModificationSchoolType: {
          description: 'Triggered when the user modifies the School Type field.',
          eventHub: {
            code: 'FieldModificationSchoolType',
            action: 'Field_Modification_School_Type',
            dataKeys: ['screenName', 'value']
          },
          ga: {
            action: 'COS — Field_Modification_School_Type'
          }
        },
        CosFieldModificationYears: {
          description: 'Triggered when the user modifies the Years of Tuition field.',
          eventHub: {
            code: 'FieldModificationYears',
            action: 'Field_Modification_Years',
            dataKeys: ['screenName', 'value']
          },
          ga: {
            action: 'COS — Field_Modification_Years'
          }
        },
        CosFieldModificationLocation: {
          description: 'Triggered when the user modifies the School Location field.',
          eventHub: {
            code: 'FieldModificationLocation',
            action: 'Field_Modification_Location',
            dataKeys: ['screenName', 'value']
          },
          ga: {
            action: 'COS — Field_Modification_Location'
          }
        }
      }
    }
  }
};
